//@ts-check
import React from 'react';
import ReactDOM from 'react-dom';
import { useWipeInnerHtmlOnInit } from 'src/scripts/utils/react/hooks/portals';
import { useCartData } from '../../../../utils/cart';

import { MiniCart } from './Minicart';

const targetElements = Array.from(document.querySelectorAll('[react-render-target="header-minicart"]'));
const CartLogic = () => {
  const cartData = useCartData();
  const [severRenderRemoved] = useWipeInnerHtmlOnInit(targetElements);

  const children = targetElements.map((domNode, index) =>
    ReactDOM.createPortal(<MiniCart key={`minicart-${index}`} cartData={cartData} />, domNode)
  );
  if (!severRenderRemoved) return <>{null}</>;
  return <>{children}</>;
};

export { CartLogic };
